import { apiClient } from './api'

export interface ProgramBudget {
  id: number
  program_id: number
  total_budget: number
  allocated_budget: number
  spent_budget: number
  remaining_budget: number
  cost_performance_index: number | null
  period_start: string | null
  period_end: string | null
  metadata?: Record<string, unknown>
}

export interface ProgramBudgetCategory {
  id: number
  program_id: number
  category: string
  allocated: number
  spent: number
  remaining: number
  metadata?: Record<string, unknown>
}

export const programBudgetService = {
  async getSummary(programId: number): Promise<ProgramBudget> {
    const response = await apiClient.get<ProgramBudget>(`/api/v1/programs/${programId}/budget`)
    return response.data
  },

  async listCategories(programId: number): Promise<ProgramBudgetCategory[]> {
    const response = await apiClient.get<ProgramBudgetCategory[]>(`/api/v1/programs/${programId}/budget/categories`)
    return response.data
  },

  async addCategory(programId: number, data: { category: string; allocated: number; spent?: number }): Promise<ProgramBudgetCategory> {
    const response = await apiClient.post<ProgramBudgetCategory>(`/api/v1/programs/${programId}/budget/categories`, data)
    return response.data
  },

  async updateCategory(programId: number, categoryId: number, data: { category?: string; allocated?: number; spent?: number }): Promise<ProgramBudgetCategory> {
    const response = await apiClient.put<ProgramBudgetCategory>(`/api/v1/programs/${programId}/budget/categories/${categoryId}`, data)
    return response.data
  },

  async deleteCategory(programId: number, categoryId: number): Promise<void> {
    await apiClient.delete(`/api/v1/programs/${programId}/budget/categories/${categoryId}`)
  },
}

